import RecentlyViewedRootView from './RecentlyViewedRootView'
import RecentlyViewedRootViewContainer from './RecentlyViewedRootViewContainer'

export { RecentlyViewedRootView }
export default RecentlyViewedRootViewContainer
